/*=============================================================================
 * Copyright (C) 2017 Stephen F. Norledge and Alces Flight Ltd.
 *
 * This file is part of Alces Prime.
 *
 * All rights reserved, see LICENSE.txt.
 *===========================================================================*/
import React from 'react';
import { Button, ButtonToolbar, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
var defaultProps = {
  cancelIcon: 'times-circle',
  cancelText: 'Cancel',
  confirmIcon: 'check-circle',
  confirmColor: 'warning',
  confirmText: 'OK',
  placement: 'top'
};

var PopoverConfirmation = function PopoverConfirmation(_ref) {
  var cancelIcon = _ref.cancelIcon,
      cancelText = _ref.cancelText,
      children = _ref.children,
      confirmColor = _ref.confirmColor,
      confirmIcon = _ref.confirmIcon,
      confirmText = _ref.confirmText,
      onConfirmation = _ref.onConfirmation,
      onHide = _ref.onHide,
      placement = _ref.placement,
      show = _ref.show,
      target = _ref.target,
      title = _ref.title;
  return /*#__PURE__*/React.createElement(Popover, {
    isOpen: show,
    placement: placement,
    target: target,
    title: title,
    toggle: onHide
  }, /*#__PURE__*/React.createElement(PopoverHeader, null, title), /*#__PURE__*/React.createElement(PopoverBody, null, children, /*#__PURE__*/React.createElement(ButtonToolbar, {
    className: "justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onHide
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: cancelIcon
  }), ' ', cancelText), /*#__PURE__*/React.createElement(Button, {
    className: "ml-1",
    color: confirmColor,
    onClick: onConfirmation
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: confirmIcon
  }), ' ', confirmText))));
};

PopoverConfirmation.defaultProps = defaultProps;
export default PopoverConfirmation;